import { render, staticRenderFns } from "./StepEnd.vue?vue&type=template&id=b2a0f8f0&scoped=true&"
import script from "./StepEnd.vue?vue&type=script&lang=js&"
export * from "./StepEnd.vue?vue&type=script&lang=js&"
import style0 from "./StepEnd.vue?vue&type=style&index=0&id=b2a0f8f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a0f8f0",
  null
  
)

export default component.exports